import React from 'react'
import injectStyles from 'react-jss'
import { SectionWrapper } from '../../Section/SectionWrapper'
import { SectionTitle } from '../../Section'
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator'
import styles from '../styles'

const CampaignQuoteView = ({ loading, children, simpleView, classes }) => {
  if (simpleView) return children

  return (
    <SectionWrapper className={`section-wrapper ${classes.wrapper}`}>
      <SectionTitle>Campaign Quote</SectionTitle>
      {children}
      {loading && (
        <div className={classes.loadingContainer}>
          <LoadingIndicator />
        </div>
      )}
      * Density is shown per square kilometre
    </SectionWrapper>
  )
}

export default injectStyles(styles)(CampaignQuoteView)



// WEBPACK FOOTER //
// ./src/Components/CampaignQuote/component/CampaignQuoteView.jsx